export enum AnalysisType {
  FCD = 'FCD',
  DETECTOR = 'DETECTOR',
}
